<div class="flex-column middle justify section container">
    <mat-form-field class="fields site-search-field" *ngIf="showSiteDropdown$ | async">
        <mat-label>Site</mat-label>
        <mat-select [value]="selectedSite" (valueChange)="selectSite($event)" (closed)="onSiteDropdownClosed()">
            <mat-option class="input-option">
                <mat-form-field appearance="outline" class="site-search-input"
                    (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    <mat-label (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                        Search Site
                    </mat-label>
                    <input matInput [formControl]="searchControl" (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()" autocomplete="off" />
                </mat-form-field>
            </mat-option>
            <mat-option *ngFor="let site of filteredSites$ | async" [value]="site">
                {{ site.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="fields">
        <mat-label>Emails for Alerts</mat-label>
        <mat-chip-grid #chipGrid aria-label="Email alert recipients">
            <mat-chip-row *ngFor="let email of alertEmails" (removed)="removeEmail(email)" [removable]="true">
                {{ email }}
                <button matChipRemove [attr.aria-label]="'Remove ' + email">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
        </mat-chip-grid>
        <input placeholder="Email for Alerts" [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addEmail($event)" [formControl]="emailFormControl" type="email" />
    </mat-form-field>

    <button mat-raised-button color="primary" class="section container mt-20"
        [disabled]="!valid()"
        (click)="saveSettings()">
        Save Alert Settings
    </button>
</div>
